import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'label-text-pair',
    templateUrl: './label-text-pair.component.html',
    styleUrls: ['./label-text-pair.component.css']
})
export class LabelTextPairWidget {
	@Input() label:string;
	private  _required:any;
	private  _disabled:any;
	@Input() model:any;
	@Input() type:string;
	@Input() icon:string;
    @Input() invalid: boolean = false;
	@Input() large:boolean;

	@Output() modelChange: EventEmitter<any> = new EventEmitter();


	@Input()
	set required(required: string) {
		this._required = required === "" || required === "true";

	}

	get required(): string { return this._required; }

	@Input()
	set disabled(disabled: string) {
		this._disabled = disabled === "" || disabled === "true";

	}

	get disabled(): string { return this._disabled; }


	onChanges(newValue) {
		this.model = newValue;
		this.modelChange.emit(newValue);
	}
}
